// Recovered compiled webpack factory 42106. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { Jz: () => a, wq: () => o });
  var n = r(78714);
  function a(e, t, r = (0, n.Wk)()) {
    return (e[t] || e.all || 0) > r;
  }
  function o(e, { statusCode: t, headers: r }, a = (0, n.Wk)()) {
    let i = { ...e },
      s = r?.["x-sentry-rate-limits"],
      l = r?.["retry-after"];
    if (s)
      for (let e of s.trim().split(",")) {
        let [t, r, , , n] = e.split(":", 5),
          o = parseInt(t, 10),
          s = (isNaN(o) ? 60 : o) * 1e3;
        if (r)
          for (let e of r.split(";"))
            "metric_bucket" === e
              ? (!n || n.split(";").includes("custom")) && (i[e] = a + s)
              : (i[e] = a + s);
        else i.all = a + s;
      }
    else
      l
        ? (i.all =
            a +
            (function (e, t = (0, n.Wk)()) {
              let r = parseInt(`${e}`, 10);
              if (!isNaN(r)) return 1e3 * r;
              let a = Date.parse(`${e}`);
              return isNaN(a) ? 6e4 : a - t;
            })(l, a))
        : 429 === t && (i.all = a + 6e4);
    return i;
  }
}
